import React, { useEffect, useState } from "react";
import axios from "axios";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { ROOT_API } from "../../../api/config";
import { formatDateTime } from "../../../utils/dates";
import "../subscriptions/style.scss";
import "../bills/style.scss";
import "./style.scss";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
});

const euro = (minor, currency) =>
  minor != null ? `${(minor / 100).toFixed(2)} ${currency || "EUR"}` : "—";

const PLAN_LABEL = {
  free: "Free",
  premium: "Premium",
  premium_yearly: "Premium",
  business: "Business",
  credits: "SMS",
};

export default function Referrals() {
  const intl = useIntl();
  const selectedLocale =
    useSelector((state) => state.lang.value) ||
    localStorage.getItem("lang") ||
    "hr";
  const locale = selectedLocale === "en" ? "en-US" : "hr-HR";

  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${ROOT_API}apis/admin/referrals`, {
          headers: authHeaders(),
        });
        if (alive) setCodes(res?.data?.data || []);
      } catch (e) {
        if (alive) setCodes([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="admin-subs__state">
        {intl.formatMessage({ id: "dashboard_loading" })}
      </div>
    );
  }

  if (!codes.length) {
    return (
      <div className="admin-subs__state">
        {intl.formatMessage({ id: "admin_ref_empty" })}
      </div>
    );
  }

  return (
    <div className="admin-refs">
      {codes.map((c) => (
        <section className="admin-refs__card" key={c.code}>
          <div className="admin-refs__head">
            <div>
              <h3 className="admin-refs__code">{c.code}</h3>
              <span className="admin-refs__pct">
                {intl.formatMessage(
                  { id: "admin_ref_referrer_cut" },
                  { n: c.referrer_percent }
                )}
              </span>
            </div>
            <div className="admin-refs__stats">
              <div className="admin-refs__stat">
                <strong>{c.uses_paid}</strong>
                <span>{intl.formatMessage({ id: "admin_ref_paid_uses" })}</span>
              </div>
              <div className="admin-refs__stat">
                <strong>{euro(c.sales_minor, c.currency)}</strong>
                <span>{intl.formatMessage({ id: "admin_ref_sales" })}</span>
              </div>
              <div className="admin-refs__stat admin-refs__stat--payout">
                <strong>{euro(c.payout_minor, c.currency)}</strong>
                <span>{intl.formatMessage({ id: "admin_ref_payout" })}</span>
              </div>
            </div>
          </div>
          <table className="admin-subs__table">
            <thead>
              <tr>
                <th>{intl.formatMessage({ id: "admin_bills_invoice" })}</th>
                <th>{intl.formatMessage({ id: "admin_col_user" })}</th>
                <th>{intl.formatMessage({ id: "admin_bills_plan" })}</th>
                <th>{intl.formatMessage({ id: "admin_bills_amount" })}</th>
                <th>{intl.formatMessage({ id: "admin_bills_when" })}</th>
                <th>{intl.formatMessage({ id: "admin_bills_state" })}</th>
              </tr>
            </thead>
            <tbody>
              {c.redemptions.map((r) => (
                <tr key={r.invoice_number}>
                  <td>
                    <strong>{r.invoice_number || "—"}</strong>
                  </td>
                  <td>
                    <div className="admin-subs__name">{r.full_name || "—"}</div>
                    <div className="admin-subs__email">{r.email}</div>
                  </td>
                  <td>{PLAN_LABEL[r.plan] || r.plan}</td>
                  <td>{euro(r.amount_minor, r.currency)}</td>
                  <td>{formatDateTime(r.created_at, locale)}</td>
                  <td>
                    <span
                      className={`admin-bills__state admin-bills__state--${r.state}`}
                    >
                      {intl.formatMessage({ id: `admin_bills_state_${r.state}` })}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  );
}
